import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from './DefaultModal';
import useDefaultModal from '../hooks/useDefaultModal';

function CompraDiretaItemModal({ show, item, compra, onClose, onSave }) {
  const [formData, setFormData] = useState({
    descricao: '',
    marca: '',
    unidade: '',
    quantidade: 0,
    valorUnitario: '',
  });
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (show) {
      if (item) {
        setFormData({
          descricao: item.descricao || '',
          marca: item.marca || '',
          unidade: item.unidade || '',
          quantidade: item.quantidade || 0,
          valorUnitario: item.valorUnitario || '',
        });
      } else {
        setFormData({ descricao: '', marca: '', unidade: '', quantidade: 0, valorUnitario: '' });
      }
      setValidated(false);
    }
  }, [show, item]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const calcularValorTotal = () => {
    const qtd = parseFloat(formData.quantidade) || 0;
    const vlrUnit = parseFloat(formData.valorUnitario) || 0;
    return qtd * vlrUnit;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!formData.descricao) {
      setValidated(true);
      return;
    }
    setLoading(true);
    const payload = {
      ...formData,
      idCompraDireta: compra.id,
      quantidade: parseFloat(formData.quantidade) || 0,
      valorUnitario: parseFloat(formData.valorUnitario) || 0,
    };

    try {
      if (item?.sequencial) {
        await axios.put(`${API_BASE_URL.COMPRA_DIRETA_ITEM}/${compra.id}/itens/${item.sequencial}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (onSave) onSave();
        if (onClose) onClose();
        showDefaultModal('success', 'Item atualizado com sucesso!');
      } else {
        await axios.post(`${API_BASE_URL.COMPRA_DIRETA_ITEM}/${compra.id}/itens`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (onSave) onSave();
        if (onClose) onClose();
        showDefaultModal('success', 'Item cadastrado com sucesso!');
      }
    } catch (error) {
      console.error('Erro ao salvar item:', error);
      showDefaultModal('error', 'Erro ao salvar item. Verifique os dados e tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div
              className="modal-header text-white"
              style={{
                background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
                padding: '0.5rem 1rem',
                borderTopLeftRadius: '0.5rem',
                borderTopRightRadius: '0.5rem',
                border: 'none',
              }}
            >
              <h6 className="modal-title mb-0">
                <i className="bi bi-list-ul me-2"></i>
                {item ? 'Editar Item' : 'Novo Item'}
              </h6>
              <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={loading} title="Fechar"></button>
            </div>
            <div className="modal-body">
              <div className="alert alert-info mb-3 py-2">
                <small>
                  <i className="bi bi-info-circle me-2"></i>
                  Compra Direta: <strong>{compra.numCompra}</strong>
                  {compra.ano && <>/{compra.ano}</>}
                  {compra.data && <> — Data: <strong>{new Date(compra.data + 'T00:00:00').toLocaleDateString('pt-BR')}</strong></>}
                </small>
              </div>
              <form onSubmit={handleSubmit} noValidate>
                <div className="mb-3">
                  <label className="form-label small fw-semibold">
                    Descrição <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className={`form-control ${validated && !formData.descricao ? 'is-invalid' : ''}`}
                    rows={3}
                    name="descricao"
                    value={formData.descricao}
                    onChange={handleChange}
                    placeholder="Descrição do item..."
                    disabled={loading}
                  />
                  {validated && !formData.descricao && (
                    <div className="invalid-feedback">Por favor, informe a descrição.</div>
                  )}
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Marca</label>
                      <input type="text" className="form-control" name="marca" value={formData.marca} onChange={handleChange} maxLength={100} disabled={loading} />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Unidade</label>
                      <input type="text" className="form-control" name="unidade" value={formData.unidade} onChange={handleChange} maxLength={50} placeholder="Ex: UN, KG, CX" disabled={loading} />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Quantidade</label>
                      <input type="number" className="form-control" name="quantidade" value={formData.quantidade} onChange={handleChange} min={0} step="0.01" placeholder="0,00" disabled={loading} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Valor Unitário (R$)</label>
                      <input type="number" className="form-control" name="valorUnitario" value={formData.valorUnitario} onChange={handleChange} step="0.01" min={0} placeholder="0,00" disabled={loading} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Valor Total</label>
                      <input
                        type="text"
                        className="form-control bg-light fw-bold"
                        value={new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(calcularValorTotal())}
                        disabled
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end gap-2">
                  <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
                    <i className="bi bi-x-circle me-1"></i>Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? (
                      <><span className="spinner-border spinner-border-sm me-1"></span>Salvando...</>
                    ) : (
                      <><i className="bi bi-check-circle me-1"></i>Salvar</>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default CompraDiretaItemModal;
